module.exports = __webpack_public_path__ + "img/dna-house-vertical.df4f5c6d.png";